<template>
  <div>
    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('QUOTE_DATE') + ': ', $t('MODEL') + ': ', $t('DELTA_EXCHANGE_RATE') + ': ']"
        :fieldWidthArr="[444, 444, 444]" :fieldSpanWidthArr="[182, 182, 182]">
        <Input class="Input" v-model="today" slot="a" :disabled="true" />
        <Input class="Input" v-model="pwbQuotation.model" slot="b" :disabled="true" />
        <Input class="Input" v-model="pwbQuotation.deltaExchangeRate" slot="c" :disabled="true" />
      </FormRowTwo>

      <FormRowTwo :fieldNameArr="[$t('CPC_EXCHANGE_RATE') + ': ', 'RFQ Base' + ': ']" :fieldWidthArr="[444, 444]"
        :fieldSpanWidthArr="[182, 182]">
        <Input class="Input" v-model="pwbQuotation.cpcExchangeRate" slot="a" :disabled="true" />
        <Input class="Input" v-model="pwbQuotation.rfqBase" slot="b" :disabled="true" />
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('CCL_FIELD')" :iconClass="'fa-pencil-square-o'">
      <Card :title="$t('PWB_CASE_ATTRIBUTES')" class="card-info">
        <FormRowTwo :fieldNameArr="[$t('CCL_LAMINATE_TYPE') + ': ']" :fieldWidthArr="[414]" :fieldSpanWidthArr="[152]">
          <Input class="Input" v-model="pwbQuotation.cclLaminateType" slot="a" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('LAYER') + ': ', $t('PCB_THICKNESS') + ': ', $t('TG') + ': ', $t('EXTERNAL_COPPER_THICKNESS_TITLE') + ': ', $t('INTERNAL_COPPER_THICKNESS_TITLE') + ': ', $t('INTERNAL_CORE_THICKNESS_TITLE') + ': ']"
          :fieldWidthArr="[414, 414, 414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152, 152, 152]">
          <Input class="Input" v-model="pwbQuotation.layer" slot="a" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.pcbThickness" slot="b" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.tg" slot="c" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.externalCopperThickness" slot="d" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.internalCopperThickness" slot="e" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.internalCoreThickness" slot="f" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('MAIN_CCL_SUPPLIER') + ': ', $t('MAIN_CCL_UL_NUMBER') + ': ', $t('MAIN_CORE_UP') + ': ', $t('MAIN_SOURCE_CCL_SHARE') + ': ']"
          :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
          <Input class="Input" v-model="mainSourceCclSupplier" slot="a" :disabled="true" />
          <Input class="Input" v-model="mainCoreUlNumber" slot="b" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.mainCoreUP" slot="c" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.mainSourceCclShare" slot="d" :disabled="true" />
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('SECOND_CCL_SUPPLIER') + ': ', $t('SECOND_CCL_UL_NUMBER') + ': ', $t('SECOND_CORE_UP') + ': ', $t('SECOND_SOURCE_CCL_SHARE') + ': ']"
          :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
          <Input class="Input" v-model="secondSourceCclSupplier" slot="a" :disabled="true" />
          <Input class="Input" v-model="secondCoreUlNumber" slot="b" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.secondCoreUP" slot="c" :disabled="true" />
          <Input class="Input" v-model="pwbQuotation.secondSourceCclShare" slot="d" :disabled="true" />
        </FormRowTwo>
      </Card>
    </Feature>

    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <Tabs>
        <TabPane :label="'A.' + this.$t('MATERIAL_COST')">
          <FormRowTwo :fieldNameArr="[$t('PCB_PRICE_SHEET_OR_ACTUAL_PANEL_BASE') + ': ']">
            <Input class="Input" v-model="pwbQuotation.pcbPrice" slot="a" :disabled="true" />
          </FormRowTwo>
          <FormRowTwo
            :fieldNameArr="[$t('PANEL_LENGTH') + '(mm)' + ': ', $t('PANEL_WIDTH') + '(mm)' + ': ', $t('PN_LENGTH') + '(mm)' + ': ', $t('PN_WIDTH') + '(mm)' + ': ', $t('PN_IN_PANEL') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
            <Input class="Input" v-model="pwbQuotation.panelLength" slot="a" :disabled="true" />
            <Input class="Input" v-model="pwbQuotation.panelWidth" slot="b" :disabled="true" />
            <Input class="Input" v-model="pwbQuotation.pnLength" slot="c" :disabled="true" />
            <Input class="Input" v-model="pwbQuotation.pnWidth" slot="d" :disabled="true" />
            <Input class="Input" v-model="pwbQuotation.pnInPanel" slot="e" :disabled="true" />
          </FormRowTwo>
          <Card :title="$t('SHEET_DATA')" class="card-info">
            <FormRowTwo
              :fieldNameArr="[$t('DELTA_SHEET_SIZE') + '(inch)' + ': ', $t('SUPPLIER_SHEET_SIZE') + '(inch)' + ': ', $t('PANEL_SHEET') + ': ', $t('PN_IN_SHEET') + '(Pcs/Sheet)' + ': ']"
              :fieldWidthArr="[444, 444, 444, 444]" :fieldSpanWidthArr="[182, 182, 182, 182]">
              <Input class="Input" v-model="pwbQuotation.deltaSheetSize" slot="a" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.supplierSheetSize" slot="b" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.panelSheet" slot="c" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.pnInSheet" slot="d" :disabled="true" />
            </FormRowTwo>
            <FormRowTwo
              :fieldNameArr="[$t('PANEL_AREA') + '(m*m)' + ': ', $t('PN_AREA') + '(m*m)' + ': ', $t('PN_UTILIZATION') + '(%)' + ': ', $t('PANEL_UTILIZATION') + '(%)' + ': ']"
              :fieldWidthArr="[444, 444, 444, 444]" :fieldSpanWidthArr="[182, 182, 182, 182]">
              <Input class="Input" v-model="pwbQuotation.area" slot="a" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.pnArea" slot="b" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.pnUtilization" slot="c" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.panelUtilization" slot="d" :disabled="true" />
            </FormRowTwo>
            <FormRowTwo
              :fieldNameArr="[$t('AB_COMBINE_RATIO') + '(%)' + ': ', $t('NUMBER_OF_DRILL_QTY') + ': ', $t('SLOT_LENGTH') + '(m)' + ': ', $t('GOLD_AREA') + '(mm*mm)' + ': ']"
              :fieldWidthArr="[444, 444, 444, 444]" :fieldSpanWidthArr="[182, 182, 182, 182]">
              <Input class="Input" v-model="pwbQuotation.combineRatio" slot="a" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.numberOfDrill" slot="b" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.slotLength" slot="c" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.goldArea" slot="d" :disabled="true" />
            </FormRowTwo>
            <FormRowTwo
              :fieldNameArr="[$t('PN_CODE_CCL_AREA') + '(m2))' + ': ', $t('NUMBER_OF_INNER_CORE_CCL_SHEETS') + ': ']"
              :fieldWidthArr="[444, 444]" :fieldSpanWidthArr="[182, 182]">
              <Input class="Input" v-model="pwbQuotation.pnCoreDivisionArea" slot="a" :disabled="true" />
              <Input class="Input" v-model="pwbQuotation.innerCoreDivisionCclSheets" slot="b" :disabled="true" />
            </FormRowTwo>
          </Card>
        </TabPane>
        <TabPane :label="'B.' + this.$t('SURFACE_FINISH_COST')">
          <FormRow :fieldNameArr="['']">
            <Table width="900" border :columns="surfaceCostItemSchema" :data="surfaceCostItems" slot="a"></Table>
          </FormRow>
        </TabPane>
        <TabPane :label="'C.' + this.$t('PROCESS_COST')">
          <FormRow :fieldNameArr="['']">
            <Table width="900" border :columns="processCostItemSchema" :data="processCostItems" slot="a"></Table>
          </FormRow>
        </TabPane>
      </Tabs>
    </Feature>

    <FormRow :fieldNameArr="[$t('')]">
      <Table width="600" border :columns="priceColumnList" :data="priceList" slot="a">
      </Table>
    </FormRow>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { DateToString } from "@/util/common"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "PwbAttributes",
  props: {
    pwbQuotation: {
      type: Object,
      default: () => null,
    },
    priceList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    FormRowTwo
  },
  data() {
    return {
      surfaceCostItemSchema: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('SURFACE_COST_ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'costItemName',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPrice',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE_FOR_PCS_SHEET')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPriceForPcsSheet',
          align: 'center',
        }
      ],
      processCostItemSchema: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_COST_ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'costItemName',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPrice',
          align: 'center',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE_FOR_PCS_SHEET')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'unitPriceForPcsSheet',
          align: 'center',
        }
      ],
      priceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.key) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.value) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        }
      ]
    }
  },
  methods: {
    ...mapGetters(["getModalSize"]),
    ...mapActions([]),
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    today() {
      return DateToString(new Date(), "/")
    },
    surfaceCostItems() {
      return this.pwbQuotation.pwbCostItems ? this.pwbQuotation.pwbCostItems.filter(item => item.type == "SURFACE") : []
    },
    processCostItems() {
      return this.pwbQuotation.pwbCostItems ? this.pwbQuotation.pwbCostItems.filter(item => item.type == "PROCESS") : []
    },
    mainSourceCclSupplier() {
      return this.pwbQuotation.mainSourceCclSupplier ? this.pwbQuotation.mainSourceCclSupplier.vendorName : ""
    },
    mainCoreUlNumber() {
      return this.pwbQuotation.mainCoreUlNumber ? this.pwbQuotation.mainCoreUlNumber.partNoDesc : ""
    },
    secondSourceCclSupplier() {
      return this.pwbQuotation.secondSourceCclSupplier ? this.pwbQuotation.secondSourceCclSupplier.vendorName : ""
    },
    secondCoreUlNumber() {
      return this.pwbQuotation.secondCoreUlNumber ? this.pwbQuotation.secondCoreUlNumber.partNoDesc : ""
    }
  },
}
</script>

<style scoped></style>
  